import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FirmValidationForm from './FirmValidationForm';
import WelcomeMessage from './WelcomeMessage';
import SummaryPage from './SummaryPage';
import BillingEntityPage from './BillingEntityPage';
import OpportunityCreationPage from './OpportunityCreationPage';
import OpportunityCreationPage2 from './newUserCopy';
import OpportunityCreationPage3 from './newUserCopyLayout';
import OpportunityCreationPage4 from './userCopyLayoutOnly';
import CurrencyPage from './currencyPage';
import OptionsPage from './OptionsPage';
import AccountsPage from './accountsPage';
import Footer from './Footer';
import VerifyPage from './verification';
import ConnectionsPage from './newC9Connection';


function App() {
    const [isValid, setIsValid] = useState(false);
    const [firmName, setFirmName] = useState('');
    const [firmId, setFirmId] = useState('');
    const [currency, setCurrency] = useState('');
    const [accountId, setAccountId] = useState('');
    const [email, setEmail] = useState('');

    // const handleValidSubmit = (firmName, firmId, currency, accountId)  => {
    //     // console.log(firmName)
    //     setIsValid(true);
    //     setFirmName(firmName);
    //     console.log('@ app js level');
    //     console.log(firmId);
    //     setFirmId(firmId);
    //     setCurrency(currency);
    //     setAccountId(accountId);
    // };
    const handleValidSubmit = (email)  => {
        // console.log(firmName)
        setIsValid(true);
        setEmail(email);
        //setCurrency(currency);
    };

    return (
      <Router>
      <div className="App">
          <Routes>
              {/* <Route path="/firm" element={
                  isValid ? <WelcomeMessage firmName={firmName} firmId = {firmId} currency = {currency} /> : <FirmValidationForm onValidSubmit={handleValidSubmit} />
              } /> */}
               {/* <Route path="/orderform" element={
                    <WelcomeMessage firmName={firmName} firmId={firmId} currency={currency}  /> } /> */}
                 {/* <Route path="/billingEntity" element={
                    <BillingEntityPage firmName={firmName} firmId={firmId} currency={currency} accountId = {accountId}  /> } /> */}
               
                 <Route path="/accountsPage" element={
                    <AccountsPage /> } />
                 <Route path="/optionsPage" element={
                    <OptionsPage firmName={firmName} firmId={firmId} currency={currency} accountId = {accountId}  /> } />
                <Route path="/currencyPage" element={<CurrencyPage />} />
                <Route path="/firm" element={
                     <FirmValidationForm onValidSubmit={handleValidSubmit} />
                    } />
                <Route path="/" element={
                     <FirmValidationForm onValidSubmit={handleValidSubmit} />
                    } />
                <Route path = "/verify" element = {<VerifyPage/>} />
                <Route path="/create-opportunity" element={<OpportunityCreationPage />} />
                <Route path="/createUserCopy" element={<OpportunityCreationPage2/>} />
                <Route path="/createUserLayout" element={<OpportunityCreationPage3 />} />
                <Route path="/create-opportunity" element={<OpportunityCreationPage />} />
                <Route path= "/copyUserLayout" element = {<OpportunityCreationPage4/>} />
                <Route path= "/connections" element = {<ConnectionsPage/>} />
                <Route path="/summary" element={
                     <SummaryPage  />
                    } />
          </Routes>
          <Footer />
      </div>
  </Router>
    );
}

export default App;


//import InputPage from './components/InputPage';
//import ProductPage from './components/ProductPage';